import request from '@/utils/request'

/** 会员商城：按取件码查询提货订单（后端校验属该门店且状态=待自提） */
export function queryByPickupCode(data) {
  return request({
    url: '/api/Extend/LqMallOrder/QueryByPickupCode',
    method: 'get',
    data
  })
}

/** 会员商城：提货核销（待自提→已完成，记核销人） */
export function verify(data) {
  return request({
    url: '/api/Extend/LqMallOrder/Verify',
    method: 'post',
    data
  })
}

/** 会员商城：本门店会员预约列表（StoreId 必填） */
export function getStoreAppointmentList(data) {
  return request({
    url: '/api/Extend/LqMallAppointment/GetStoreList',
    method: 'get',
    data
  })
}

/** 会员商城：确认会员预约（待确认→已确认，传 StoreId 校验归属） */
export function confirmAppointment(data) {
  return request({
    url: '/api/Extend/LqMallAppointment/Confirm',
    method: 'put',
    data
  })
}

/** 会员商城：取消会员预约（传 StoreId 校验归属） */
export function cancelAppointment(data) {
  return request({
    url: '/api/Extend/LqMallAppointment/AdminCancel',
    method: 'put',
    data
  })
}
